export const GET_SECTION_BLOCK_BY_ID_M = (id, preview: boolean) => `
  query {
    sectionblock(id: "${id}", preview: ${preview}) {
      sys {
        id
      }
      heading
      initialPreamble {
        json
        links {
          entries {
            hyperlink {
              ... on Page {
                sys {
                  id
                }
                slug
                content {
                  __typename
                }
              }
            }
          }
        }
      }
      initialLink{
        linkText
        globalLinkItem
        reference {
          ... on Page {
            content {
              __typename
            }
            slug
          }
          ... on FileBlock {
            imageVaultFile
          }
        }
        url
      }
      contentDirection
      columns
      isWide
      backgroundColor
      showImage
      showHeading
      showText
      showLinks
      smallImages
      linkOnSection {
        linkText
        globalLinkItem
        reference {
          ...on Page {
            content {
              __typename
            }
            slug
          }
          ...on FileBlock
          {
            imageVaultFile
          }
        }
        url
      }
      audienceCollection{
        items{
            __typename
            sys{id}
            audianceId
          }
      }
      columnAreaCollection {
        items {
          __typename
          ...on AccordionBlock {sys {id}}
          ...on TeaserBlock {sys {id}}
          ...on Page {sys {id}}
          ...on Videoblock{sys {id}}
          ...on QuoteBlock{sys {id}}
          ...on ShortCutsBlock{sys{id}}
          ...on ImageBlock{sys{id}}
          ...on ContactBlock{sys{id}}
          ...on RichTextBlock{sys{id}}
          ...on Link{sys{id}}
          ...on ListBlock{sys{id}}
          ...on QuizBlock{sys{id}}
          ...on TeaserListBlock{sys{id}}
          ... on BannerBlock {
            sys {
              id
            }
          }
            ... on ContactUsBlock {
            sys {
              id
            }
          }
          ... on LinkTeaserBlock {sys{id}}
          ... on TextList {sys{id}}
          ... on PaymentDaysBlock {sys{id}}
          ... on FaqListBlock {sys{id}}
        }
      }
    }
  }
`;
